import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  quickview: {
    width: 420,
    height: '100%',
    maxWidth: '100%',
    position: 'fixed',
    right: -500,
    top: 0,
    background: 'white',
    zIndex: 107,
    transition: 'right 0.2s linear',
    overflow: 'auto',

    '&.--active': {
      right: 0,
    },

    '& .header': {
      display: 'flex',
      justifyContent: 'space-between',
      height: 50,
      alignItems: 'center',
      borderBottom: '1px solid #d9d9d9',
      fontWeight: 600,

      '& .close': {
        width: 50,
        height: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        marginLeft: 8,
      },

      '& .title': {
        width: 'calc(100% - 58px)',
        padding: '0 16px',
      },
    },

    '& .body': {
      width: '100%',
      padding: 16,
    },
  },

  overlay: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 105,
  },
}));

export default styles;
